/**
 * Security Utility Module
 * Centralized sanitization and validation logic following AppSec best practices.
 */

export const Security = {
  /**
   * Sanitizes user input to prevent basic XSS and injection.
   * Note: React handles most XSS, but this adds a layer for data integrity.
   */
  sanitize: (str) => {
    if (typeof str !== 'string') return '';
    return str.trim().slice(0, 2000); // Enforce max length of 2k chars
  },

  /**
   * Safely access object properties to prevent Prototype Pollution.
   */
  safeGet: (obj, key, whitelist = []) => {
    if (whitelist.length > 0 && !whitelist.includes(key)) return null;
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') return null;
    return obj[key] || null;
  },

  /**
   * Generates a SQL-compatible timestamp with global replacement for reliability.
   */
  getTimestamp: () => new Date().toISOString().slice(0, 19).replace(/T/g, ' ')
};